import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box,
} from '@chakra-ui/react';
import { useAppSelector } from 'hooks';
import {
  WIP_STATUS_APPEAL_SUBMITTED,
  WIP_STATUS_APPEAL_APPROVED,
  WIP_STATUS_APPEAL_REJECTED,
} from 'variables/constants';

interface AppealMessage {
  status: 'info' | 'success' | 'error' | 'warning';
  title: string;
  description: string;
}

interface AppealStatusBannerProps {
  formStateKey: 'autoPersonalForm' | 'homePersonalForm';
}

const AppealStatusBanner = ({ formStateKey }: AppealStatusBannerProps) => {
  const wipStatus = useAppSelector((state) => state[formStateKey].wip_status);
  const appeal = useAppSelector((state) => state[formStateKey].appeal);

  const messages: Record<number, AppealMessage> = {
    [WIP_STATUS_APPEAL_SUBMITTED]: {
      status: 'info',
      title: 'Appeal Submitted',
      description:
        'Your appeal is being reviewed by underwriting. The form is now locked.',
    },
    [WIP_STATUS_APPEAL_APPROVED]: {
      status: 'success',
      title: 'Appeal Approved',
      description:
        'Your appeal has been approved! Previously flagged items are no longer required.',
    },
    [WIP_STATUS_APPEAL_REJECTED]: {
      status: 'error',
      title: 'Appeal Declined',
      description:
        'Your appeal has been declined. Please contact your underwriter.',
    },
  };

  const message = messages[wipStatus] || messages[appeal?.status];

  if (!message) return null;

  return (
    <Box mb={6}>
      <Alert
        status={message.status}
        variant="left-accent"
        borderRadius="md"
        boxShadow="sm"
      >
        <AlertIcon />
        <Box>
          <AlertTitle>{message.title}</AlertTitle>
          <AlertDescription>{message.description}</AlertDescription>
        </Box>
      </Alert>
    </Box>
  );
};

export default AppealStatusBanner;
